// Button type keys mapping to default button text values.

const submitQuad = (w, h) => [
	0,
	0,
	w,
	0.04 * h,
	w - 0.05 * w,
	h - 0.07 * h,
	0.06 * w,
	h,
];

// text: button text,
// quad: wonky rectangle shape, as a function of width and height,
// width: width of the button, in rem
// height: height of the button, in rem
const buttonTypeTable = {
	trapNormalWide: {
		text: "TrapNormal",
		quad: (w, h) => [0, 0, w, 0, 0.97 * w, h, 0.03 * w, h],
	},
	trapFlippedWide: {
		text: "TrapFlipped",
		quad: (w, h) => [0.03 * w, 0, 0.97 * w, 0, w, 0.97 * h, 0, h],
	},
	trapNormal: {
		text: "TrapNormal",
		quad: (w, h) => [0.03 * w, 0, w, 0, 0.9 * w, h, 0.1 * w, h],
	},
	trapFlipped: {
		text: "TrapFlipped",
		quad: (w, h) => [0.1 * w, 0, 0.94 * w, 0, w, 0.97 * h, 0, h],
	},
	cancel: {
		text: "Cancel",
		quad: (w, h) => [0, 0.07 * h, w, 0, w - 0.05 * w, h, 0.02 * w, h - 0.1 * h],
	},
	chapter: {
		text: "Chapter",
		quad: (w, h) => [
			0.12 * w,
			0,
			w - 0.07 * w,
			0.02 * h,
			w,
			h - 0.05 * h,
			0,
			h,
		],
	},
	chapterx: {
		text: "Chapter",
		quad: (w, h) => [
			0.12 * w,
			0,
			w - 0.07 * w,
			0.02 * h,
			w,
			h - 0.05 * h,
			0,
			h,
		],
		width: 21,
	},
	continue: {
		text: "Continue",
		quad: (w, h) => [0.1 * w, 0, w - 0.06 * w, 0, w, h - 0.03 * h, 0, h],
	},
	quit: {
		text: "Quit",
		quad: (w, h) => [0, 0, w, 0.04 * h, w - 0.02 * w, h - 0.05 * h, 0.1 * w, h],
	},
	restart: {
		text: "Restart",
		quad: (w, h) => [0, 0, w, 0.04 * h, w - 0.02 * w, h - 0.05 * h, 0.1 * w, h],
	},
	giveup: {
		text: "Give up",
		quad: (w, h) => [0, 0, w, 0.04 * h, w - 0.02 * w, h - 0.05 * h, 0.1 * w, h],
		width: 12,
	},
	"give up": {
		text: "Give up",
		quad: (w, h) => [0, 0, w, 0.04 * h, w - 0.02 * w, h - 0.05 * h, 0.1 * w, h],
		width: 12,
	},
	feelingstuck: {
		text: "Feeling stuck",
		quad: (w, h) => [
			0,
			0,
			w,
			0.02 * h,
			w - 0.03 * w,
			h - 0.05 * h,
			0.05 * w,
			h,
		],
		width: 21,
		height: 4.5,
	},
	next: {
		text: "Next",
		quad: (w, h) => [0, 0.04 * h, w, 0, w - 0.17 * w, h - 0.02 * h, 0.1 * w, h],
		width: 13,
	},
	play: {
		text: "Play",
		quad: (w, h) => [
			0.12 * w,
			0,
			w - 0.07 * w,
			0.02 * h,
			w,
			h - 0.05 * h,
			0,
			h,
		],
		width: 13,
	},
	previous: {
		hasImage: true,
		text: "Previous",
	},
	replay: {
		text: "Replay",
		quad: (w, h) => [0, 0, w, 0.04 * h, w - 0.07 * w, h - 0.03 * h, 0.1 * w, h],
	},
	replayproblem: {
		text: "Replay Problem",
		//Teacher button no quad
	},
	results: {
		text: "Results",
		quad: (w, h) => [0.04 * w, 0.15 * h, w, 0, w - 0.15 * w, h, 0.08 * w, h],
	},
	history: {
		text: "History",
		quad: (w, h) => [0.04 * w, 0.05 * h, w, 0, w - 0.05 * w, h, 0.08 * w, h],
	},
	submit: {
		text: "Submit",
		quad: submitQuad,
	},
	submitpart1: {
		text: "Submit Part 1",
		quad: (w, h) => [
			0,
			0,
			w,
			0.04 * h,
			w - 0.15 * w,
			h - 0.07 * h,
			0.12 * w,
			h,
		],
		width: 24,
		height: 4.5,
	},
	submitpart2: {
		text: "Submit Part 2",
		quad: (w, h) => [
			0,
			0,
			w,
			0.04 * h,
			w - 0.15 * w,
			h - 0.07 * h,
			0.12 * w,
			h,
		],
		width: 24,
		height: 4.5,
	},
	submitpart1small: {
		text: "Submit Part 1",
		quad: submitQuad,
		width: 14,
		height: 3.5,
		fontSize: "1.4rem",
	},
	submitpart2small: {
		text: "Submit Part 2",
		quad: submitQuad,
		width: 14,
		height: 3.5,
		fontSize: "1.4rem",
	},
	yes: {
		text: "Yes",
		quad: (w, h) => [0, 0, w, 0.02 * h, w - 0.1 * w, h - 0.05 * h, 0.15 * w, h],
	},
	signmeup: {
		text: "Sign Up",
		quad: submitQuad,
		// quad: (w, h) => [0, 0, w, 0.02 * h, w - 0.1 * w, h - 0.05 * h, 0.15 * w, h],
	},
	keeptrying: {
		text: "Keep trying",
		quad: (w, h) => [0, 0.07 * h, w, 0, w - 0.05 * w, h, 0.02 * w, h - 0.1 * h],
		width: 24,
		height: 4.5,
	},
	keepplaying: {
		text: "Keep playing",
		quad: (w, h) => [0, 0, w, 0.07 * h, w - 0.02 * w, h - 0.1 * h, 0.05 * w, h],
		width: 22,
	},
	ok: {
		text: "Okay",
		quad: (w, h) => [
			0,
			0.05 * h,
			w,
			0,
			w - 0.15 * w,
			h,
			0.11 * w,
			h - 0.07 * h,
		],
	},
	okay: {
		text: "Okay",
		quad: (w, h) => [
			0,
			0.05 * h,
			w,
			0,
			w - 0.15 * w,
			h,
			0.11 * w,
			h - 0.07 * h,
		],
	},
	gotit: {
		text: "Got it",
		quad: (w, h) => [
			0,
			0.05 * h,
			w,
			0,
			w - 0.15 * w,
			h,
			0.11 * w,
			h - 0.07 * h,
		],
		width: 10,
		height: 3,
		fontSize: "1.7rem",
	},
	getstarted: {
		text: "Get started",
		quad: (w, h) => [
			0,
			0.05 * h,
			w,
			0,
			w - 0.15 * w,
			h,
			0.11 * w,
			h - 0.07 * h,
		],
		width: 20,
		height: 4.5,
	},
	keepworking: {
		text: "Keep working",
		quad: submitQuad,
	},
	testdoublecheck: {
		text: "Keep working",
		quad: (w, h) => [
			0,
			0,
			w,
			0.04 * h,
			w - 0.15 * w,
			h - 0.07 * h,
			0.12 * w,
			h,
		],
		width: 24,
		height: 4.5,
	},
	reviewinstructions: {
		text: "Review Instructions",
		quad: (w, h) => [
			0,
			0,
			w,
			0.04 * h,
			w - 0.07 * w,
			h - 0.07 * h,
			0.06 * w,
			h,
		],
		width: 29,
		height: 4.5,
	},
	keepreading: {
		text: "Keep Reading",
		quad: (w, h) => [
			0,
			0,
			w,
			0.04 * h,
			w - 0.15 * w,
			h - 0.07 * h,
			0.12 * w,
			h,
		],
		width: 26,
	},
	viewhistory: {
		text: "View history",
		quad: (w, h) => [0.1 * w, 0, w, 0.02 * h, w - 0.03 * w, h - 0.05 * h, 0, h],
		width: 21,
		height: 4.5,
	},
	"medium-size": {
		text: "",
		quad: (w, h) => [
			0.1 * w,
			0,
			w - (0.1 / 2) * w,
			0,
			w,
			h - 0.1 * h,
			0.1 / 4,
			h,
		],
	},
	"large-size": {
		text: "",
		quad: (w, h) => [0, 0, w, 0.02 * h, w - 0.03 * w, h - 0.05 * h, 0.1 * w, h],
		width: 21,
		height: 4.5,
	},
	login: {
		text: "Sign in",
		quad: (w, h) => [0, 0.1 * h, w, 0, w - 0.1 * w, h, 0.1 * w, h],
	},
	logout: {
		text: "Sign out",
		quad: (w, h) => [0, 0.1 * h, w, 0, w - 0.1 * w, h, 0.1 * w, h],
	},
	refresh: {
		text: "Refresh",
		quad: (w, h) => [
			0.05 * w,
			-0.01 * h,
			w,
			-0.05 * h,
			w + 0.03 * w,
			h + 0.1 * h,
			0.1 / 4,
			h,
		],
	},
	tryagain: {
		text: "Try Again",
		quad: (w, h) => [
			0.05 * w,
			-0.01 * h,
			w,
			-0.05 * h,
			w + 0.03 * w,
			h + 0.1 * h,
			0.1 / 4,
			h,
		],
	},
	testsummary: {
		text: "Summary",
		quad: (w, h) => [
			0.05 * w,
			-0.01 * h,
			w,
			-0.05 * h,
			w + 0.03 * w,
			h + 0.1 * h,
			0.1 / 4,
			h,
		],
	},
	class: {
		text: "Class",
		quad: (w, h) => [
			0.03 * w,
			0,
			w - 0.08 * w,
			0.05 * h,
			w,
			h + 0.02 * h,
			0,
			h,
		],
		width: 20,
		height: 5,
		fontSize: "2.5rem",
	},
	library: {
		text: "Library",
		quad: (w, h) => [
			0.02 * w,
			0,
			w - 0.05 * w,
			0.05 * h,
			w,
			h,
			0,
			h - 0.02 * h,
		],
		width: 16,
		height: 4.2,
		fontSize: "1.8rem",
	},
	office: {
		text: "Office",
		quad: (w, h) => [
			0,
			0,
			w,
			0.05 * h,
			w - 0.08 * w,
			h + 0.02 * h,
			0.03 * w,
			h,
		],
		width: 16,
		height: 4.5,
		fontSize: "2rem",
	},
	more: {
		text: "More ▼",
		quad: (w, h) => [0, 0.02 * h, w, 0, w - 0.07 * w, h, 0.09 * w, h],
		width: 16,
		height: 4.5,
		fontSize: "1.5rem",
	},
	info: {
		text: "Info",
		quad: (w, h) => [
			0.02 * w,
			0,
			w - 0.08 * w,
			0.08 * h,
			w,
			h - 0.03 * h,
			0,
			h,
		],
		width: 18,
		height: 5,
		fontSize: "2rem",
	},
	halloffame: {
		text: "hall of fame",
		quad: (w, h) => [0, 0, w - 0.04 * w, 0, w, h, 0.04 * w, h],
		width: 18,
		height: 4.5,
		fontSize: "2rem",
	},
	lab: {
		text: "lab",
		quad: (w, h) => [0.02 * w, 0, w, 0.08 * h, w - 0.02 * w, h, 0, h],
		width: 10,
		height: 3.5,
		fontSize: "1.7rem",
	},
	theater: {
		text: "theater",
		quad: (w, h) => [0, 0, w, 0.01 * h, w - 0.01 * w, h, 0.08 * w, h],
		width: 15.5,
		height: 4.1,
		fontSize: "1.7rem",
	},
	selectall: {
		text: "select all",
		quad: (w, h) => [
			0,
			0,
			w,
			0.04 * h,
			w - 0.05 * w,
			h - 0.07 * h,
			0.06 * w,
			h,
		],
		height: 3,
		fontSize: "1.5rem",
	},
	buyparts: {
		text: "buy parts",
		quad: (w, h) => [0.03 * w, 0, w - 0.05 * w, 0, w, h - 0.07 * h, 0, h],
		height: 3,
		fontSize: "1.5rem",
	},
	save: {
		text: "save",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
	},
	replace: {
		text: "replace",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
	},
	saveanswer: {
		text: "save answer",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
	},
	changeanswer: {
		text: "edit answer",
		quad: (w, h) => [
			0,
			0,
			w,
			0.02 * h,
			w - 0.03 * w,
			h - 0.05 * h,
			0.05 * w,
			h,
		],
	},
	continuetest: {
		text: "continue test",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
	},
	quittest: {
		text: "quit test",
		quad: (w, h) => [
			0,
			0,
			w,
			0.02 * h,
			w - 0.03 * w,
			h - 0.05 * h,
			0.05 * w,
			h,
		],
	},
	starttest: {
		text: "start test",
		quad: (w, h) => [
			0,
			0,
			w,
			0.02 * h,
			w - 0.03 * w,
			h - 0.05 * h,
			0.05 * w,
			h,
		],
	},
	donotstarttest: {
		text: "come back later",
		quad: (w, h) => [0, 0.07 * h, w, 0, w - 0.05 * w, h, 0.02 * w, h - 0.1 * h],
	},
	home: {
		text: "home",
		quad: (w, h) => [
			0,
			0,
			w,
			0.05 * h,
			w - 0.05 * w,
			h + 0.02 * h,
			0.03 * w,
			h,
		],
		width: 14,
	},
	playlesson: {
		text: "Play Lesson",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
		width: 21,
	},
	theaterplaylesson: {
		text: "Play Lesson",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
		width: 17,
		fontSize: "1.5rem",
	},
	theaterplaylessonfullscreen: {
		text: "Play Lesson",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
		width: 22,
		fontSize: "2.2rem",
	},
	replaylesson: {
		text: "Replay Lesson",
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
		width: 15,
		height: 3,
	},
	replaycancel: {
		text: "Cancel",
		quad: (w, h) => [0, 0, w, 0.07 * h, 0.98 * w, 0.9 * h, 0.05 * w, h],
		width: 9,
		height: 3,
	},
	videolessonlocked: {
		quad: (w, h) => [
			0.04 * w,
			0,
			w - 0.04 * w,
			0.08 * h,
			w + 0.02 * w,
			h,
			0,
			h,
		],
		width: 19,
	},
	watchvideos: {
		text: "Keep Watching",
		quad: (w, h) => [
			0,
			0,
			w,
			0.05 * h,
			w - 0.05 * w,
			h + 0.02 * h,
			0.03 * w,
			h,
		],
		width: 24,
	},
	resendconfirmation: {
		text: "Resend Confirmation",
		quad: (w, h) => [
			0.1 * w,
			0,
			w - (0.1 / 2) * w,
			0,
			w,
			h - 0.1 * h,
			0.1 / 4,
			h,
		],
		width: 30,
	},
	expand: {
		quad: (w, h) => [0.05 * w, 0, w - 0.04 * w, 0, w, h - 0.05 * h, 0, h],
		width: 15,
	},
	trophyproblemprompt: {
		quad: (w, h) => [0, 0, w, 0, 0.97 * w, h, 0.03 * w, h],
		fontSize: "1.8rem",
		width: 28,
	},
	beastlessonprompt: {
		quad: (w, h) => [0, 0, w, 0, 0.97 * w, h, 0.03 * w, h],
		fontSize: "1.8rem",
		width: 26,
	},
};
// List of buttons that have variable text
const variableTextTypes = [
	"chapter",
	"medium-size",
	"large-size",
	"selectall",
	"showsolution",
	"trapNormal",
	"trapFlipped",
	"trapNormalWide",
	"trapFlippedWide",
];

module.exports = {
	buttonTypeTable,
	buttonTypeList: Object.keys(buttonTypeTable),
	variableTextTypes,
};
